"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchDarklyService = void 0;
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var helper_1 = require("../helper");
var PreloadData_service_1 = require("./PreloadData.service");
var Http_service_1 = require("../../core/services/http/Http.service");
var LaunchDarklyService = /** @class */ (function () {
    function LaunchDarklyService(httpService, seismicHelper, preloadDataService) {
        this.httpService = httpService;
        this.seismicHelper = seismicHelper;
        this.preloadDataService = preloadDataService;
    }
    /**
     * Returns all the feature toggle settings from launch darkly.
     * Notice that `cacheExpirationMinutes` is also a factor of the cache key. So if you have two calls
     * with different `cacheExpirationMinutes`, they will be cached separately.
     *
     * @param cacheExpirationMinutes The cache time in minutes, default is never expire
     * @returns All the feature toggle settings from launch darkly
     */
    LaunchDarklyService.prototype.getAllFeatureToggleSettings = function (cacheExpirationMinutes) {
        return __awaiter(this, void 0, void 0, function () {
            var preloadData, preloadFeatureToggles, ROOT_URL, url;
            return __generator(this, function (_a) {
                if (cacheExpirationMinutes === undefined) {
                    preloadData = this.preloadDataService.getPreloadData();
                    preloadFeatureToggles = (preloadData || {}).featureToggles;
                    if (preloadFeatureToggles) {
                        return [2 /*return*/, Promise.resolve(preloadFeatureToggles.flatMap(function (group) { return group.Value; }))];
                    }
                    cacheExpirationMinutes = Number.POSITIVE_INFINITY;
                }
                ROOT_URL = this.seismicHelper.getRootURL();
                url = ROOT_URL + "/api/systemsetting/v1/featureToggleSettings";
                return [2 /*return*/, this.httpService.get(url, {
                        cache: 'variable',
                        cacheExpirationMinutes: cacheExpirationMinutes,
                    })];
            });
        });
    };
    /**
     * Returns the value of a launch darkly feature toggle as a boolean from preload data.
     *
     * Notice: it will return the value from preload data or forever cached data, which means it
     * will not update the value until the end user refreshes the page. If you want a updatable value,
     * use getValueAsBooleanWithoutPreloadData instead.
     *
     * @param key The key of the feature toggle
     * @param defaultValue The default value to return if the feature toggle is not found
     * @returns A bool value of the feature toggle
     */
    LaunchDarklyService.prototype.getValueAsBoolean = function (key, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        return __awaiter(this, void 0, void 0, function () {
            var allFeatureToggles, featureToggle;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllFeatureToggleSettings()];
                    case 1:
                        allFeatureToggles = _a.sent();
                        featureToggle = allFeatureToggles.find(function (ft) { return ft.FeatureKey === key; });
                        if (!featureToggle) {
                            return [2 /*return*/, this.getValueAsBooleanWithoutPreloadData(key, defaultValue, Number.POSITIVE_INFINITY)];
                        }
                        return [2 /*return*/, featureToggle.FeatureState.toLowerCase() === 'true'];
                }
            });
        });
    };
    /**
     * Ref https://seismic.atlassian.net/browse/FEARCH-724
     * Returns the value of a launch darkly feature toggle as a boolean by calling the API,
     * with a short-time(5 mins) expiration cache.
     *
     * Notice: it will fetch the value from the API and cache it for 5 mins, so if you need a updatable value,
     * you can use it. But, at the same time, you need to take all the risks which you may need to deal with
     * the collaboration of different feature toggles. Take care!
     *
     * @param key The key of the feature toggle
     * @param defaultValue The default value to return if the feature toggle is not found
     * @returns A bool value of the feature toggle
     */
    LaunchDarklyService.prototype.getValueAsBooleanWithoutPreloadData = function (key, defaultValue, cacheExpirationMinutes) {
        if (defaultValue === void 0) { defaultValue = false; }
        if (cacheExpirationMinutes === void 0) { cacheExpirationMinutes = 5; }
        return __awaiter(this, void 0, void 0, function () {
            var allFeatureToggles, featureToggle;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllFeatureToggleSettings(cacheExpirationMinutes)];
                    case 1:
                        allFeatureToggles = _a.sent();
                        featureToggle = allFeatureToggles.find(function (ft) { return ft.FeatureKey === key; });
                        if (!featureToggle) {
                            console.info("No LaunchDarkly toggle was found for " + key + ", returning default value " + defaultValue);
                            return [2 /*return*/, defaultValue];
                        }
                        return [2 /*return*/, featureToggle.FeatureState.toLowerCase() === 'true'];
                }
            });
        });
    };
    LaunchDarklyService = __decorate([
        CommonService_decorator_1.CommonService('LaunchDarklyService'),
        __metadata("design:paramtypes", [Http_service_1.HttpService,
            helper_1.SeismicHelper,
            PreloadData_service_1.PreloadDataService])
    ], LaunchDarklyService);
    return LaunchDarklyService;
}());
exports.LaunchDarklyService = LaunchDarklyService;
//# sourceMappingURL=LaunchDarkly.service.js.map